<bit-form-field>
  <bit-label>{{ "password" | i18n }}</bit-label>
  <input bitInput type="password" [formControl]="password" required appInputVerbatim appAutofocus />
  <bit-hint>{{ "sendProtectedPasswordDontKnow" | i18n }}</bit-hint>
  <button type="button" bitIconButton bitSuffix bitPasswordInputToggle></button>
</bit-form-field>
<div class="tw-flex">
  <button
    bitButton
    bitFormButton
    type="submit"
    buttonType="primary"
    [loading]="loading()"
    [block]="true"
    startIcon="bwi-sign-in"
  >
    {{ "continue" | i18n }}
  </button>
</div>
